import React, {
  useRef,
  useEffect,
  useReducer,
  useState,
  Suspense,
} from "react";
import { Footer } from "../Footer/Footer";

import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";

import { MainMenu } from "../Navigation/MainMenu";
import {
  Typography,
  Grid,
  Stack,
  Box,
  Card,
  CardContent,
  Button,
  TextField,
  MenuItem,
  InputLabel,
  Switch,
  Checkbox,
} from "@mui/material";
import { MainMobileMenu } from "../Navigation/MainMobileMenu";

import { TextareaAutosize } from "@mui/base/TextareaAutosize";

import { useTranslation } from "react-i18next";
import ReactHtmlParser from "html-react-parser";

import EditIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/DeleteForeverOutlined";

import ShowFileOfAsset from "../FileHandlers/ShowFileOfAsset";
import AddFileToAsset from "../FileHandlers/AddFileToAsset";
import DefaultLayout from "../Layout/DefaultLayout";
import Autocomplete from "@mui/material/Autocomplete";
import currencyJSON from "../Assets/Data/Common-Currency.json";
import currencyMinJSON from "../Assets/Data/Common-Currency-min.json";
import bankNameList from "../Assets/Data/bankNames.json";
import AssetHeader from "../Commons/AssetHeader";
import AssetHeaderBottom from "../Commons/AssetHeaderBottom";
import DateFormatter from "../Commons/DateFormatter";

const EditBankAccount = ({ globalEvent, setGlobalEvent, title }) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const [chid, setChid] = useState(localStorage.chid);

  const mql = window.matchMedia("(max-width: 600px)");
  let mobileView = mql.matches;

  const formatValue = (price) => {
    let formatedPrice = price.toLocaleString("fr-FR");
    return formatedPrice.replaceAll(" ", "  ");
  };

  const [show, setShow] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);

  const handleShow = () => {
    setShow(!show);
  };

  const {
    register,
    handleSubmit,
    formState: { isDirty, isValid, errors },
    reset,
    setValue,
  } = useForm({
    mode: "onBlur",
  });

  const onSubmit = (data, e) => {
    doSaveAsset(e, collectData(data, e));
    //console.log(data, e);
  };
  const onError = (errors, e) => {
    //console.log(errors, e);
  };

  const [id, setID] = useState(null);
  const [category, setCategory] = useState("");
  const [draft, setDraft] = useState(true);
  const [name, setName] = useState("");
  const [value, setVal] = useState("");
  const [currency, setCurrency] = useState("HUF");

  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountCurrency, setAccountCurrency] = useState("HUF");
  const [hasPOD, setHasPOD] = useState(false);
  const [hasPODText, setHasPODText] = useState(false);
  const [description, setDescription] = useState("");
  const [editMode, setEditMode] = useState(false);

  const [attachmentIds, setAttachmentIds] = useState([]);
  const [attachmentFiles, setAttachmentFiles] = useState([]);

  const [accountCurrencyMore, setAccountCurrencyMore] = useState(false);
  const [currencyMore, setCurrencyMore] = useState(false);
  const [openAccountCurrency, setOpenAccountCurrency] = useState(false);

  const [showPersonalData, setShowPersonalData] = useState(false);
  const handleShowPersonalData = () => {
    setShowPersonalData(!showPersonalData);
  };

  const formRef = useRef();
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);

  useEffect(() => {
    if (isValid && bankName) {
      setIsSaveEnabled(true);
    } else {
      setIsSaveEnabled(false);
    }
  }, [isValid, bankName]);

  const [extraFields, setExtraFields] = useState([]);
  const setExtraField = (extraFieldIndex, extraFieldName, extraFieldValue) => {
    //console.log(extraFields)
    if (!extraFields[extraFieldIndex]) {
      setExtraFields((oldArray) => [
        ...oldArray,
        { name: extraFieldName, value: extraFieldValue },
      ]);
    } else {
      const nextExtraFields = [...extraFields];
      nextExtraFields[extraFieldIndex] = {
        name: extraFieldName,
        value: extraFieldValue,
      };
      setExtraFields(nextExtraFields);
    }
  };

  const deleteExtraField = (extraFieldIndex) => {
    const nextExtraFields = [...extraFields];
    nextExtraFields.splice(extraFieldIndex, 1);
    setExtraFields((oldArray) => [...nextExtraFields]);
  };

  const doSaveAsset = (event, data) => {
    event.stopPropagation();
    setGlobalEvent({ type: "doSaveAsset", data: data });
  };

  const onFileUpload = (data) => {
    
	setGlobalEvent({
      type: "checkPlan",
      data: { type: "document", subtype: "bankAccount", file: data, fileCount: attachmentFiles.length  },
    });
	
	//setGlobalEvent({
    //  type: "doFileUpload",
    //  data: { file: data, uploadType: "document" },
    //});
  };

  const collectData = (data, e) => {
    let collectedData = {};
    collectedData["asset"] = {};

    if (id * 1 > 0) {
      collectedData["asset"]["id"] = id;
    }

    collectedData["asset"]["assetType"] = "bankAccount";
    collectedData["asset"]["value"] = data.value
      ? data.value.replace(/\D/g, "") * 1
      : 0;
    collectedData["asset"]["currency"] = data.accountCurrency;
    //collectedData["asset"]["currency"] = data.currency;
    //collectedData['asset']['draft'] = draft;

    collectedData["asset"]["details"] = {};
    collectedData["asset"]["details"]["name"] = data.name;

    collectedData["asset"]["details"]["bankName"] = data.bankName;
    collectedData["asset"]["details"]["accountNumber"] = data.accountNumber;
    collectedData["asset"]["details"]["accountCurrency"] = data.accountCurrency;
    collectedData["asset"]["details"]["description"] = description;
    collectedData["asset"]["details"]["hasPOD"] = hasPOD;
    collectedData["asset"]["details"]["hasPODText"] = data.hasPODText;

    collectedData["asset"]["details"]["extraFields"] = extraFields;

    collectedData["attachmentIds"] = attachmentIds;

    return collectedData;
  };

  const setData = (data, e) => {
    //console.log("setData", data);
    setLastUpdate(data?.updatedAt);
    setID(data?.id ? data?.id : null);
    setEditMode(false);
    setVal(data?.value ? formatValue(data?.value * 1) : 0);
    setCurrency(data?.currency ? data?.currency : data?.details?.accountCurrency ? data?.details?.accountCurrency : "HUF");

    setName(data?.details?.name ? data?.details?.name : "");
    setBankName(data?.details?.bankName ? data?.details?.bankName : "");
    setAccountNumber(
      data?.details?.accountNumber ? data?.details?.accountNumber : ""
    );
    setAccountCurrency(
      data?.details?.accountCurrency ? data?.details?.accountCurrency : "HUF"
    );
    setDescription(
      data?.details?.description ? data?.details?.description : ""
    );
    setHasPOD(data?.details?.hasPOD ? data?.details?.hasPOD : "");
    setHasPODText(data?.details?.hasPODText ? data?.details?.hasPODText : "");

    setExtraFields(
      data?.details?.extraFields ? data?.details?.extraFields : []
    );
  };

  useEffect(() => {
    //console.log(state);
    setData(state?.data);
    setEditMode(state?.editmode ? state?.editmode : false);
    if (state?.data?.id) {
      setGlobalEvent({
        type: "doGetAttachments",
        data: { id: state?.data?.id },
      });
    }
  }, [state]);

  useEffect(() => {
    setValue("name", name);
  }, [name]);

  useEffect(() => {
    setValue("value", value);
  }, [value]);

  useEffect(() => {
    //setValue("currency", currency);
  }, [currency]);

  useEffect(() => {
    setValue("bankName", bankName);
  }, [bankName]);

  useEffect(() => {
    setValue("accountNumber", accountNumber);
  }, [accountNumber]);

  useEffect(() => {
    setValue("accountCurrency", accountCurrency);
    setValue("currency", accountCurrency);
  }, [accountCurrency]);

  useEffect(() => {
    //setValue(hasPOD);
  }, [hasPOD]);

  useEffect(() => {
    setValue(description);
  }, [description]);

  useEffect(() => {
    if (process.env.REACT_APP_LOG_MESSAGELOG == "on") {
      //console.log("------ Global Event ------ EditBankAccount");
      //console.log(globalEvent);
      //console.log("------------");
    }

    if (globalEvent?.type == "responseCheckPlan") {
    
	if (globalEvent?.data.subtype  == "bankAccount"){
	
	setGlobalEvent({
      type: "doFileUpload",
      data: { file: globalEvent?.data.file, uploadType: globalEvent?.data.type },
    });
	
	}
	
	}
	
	if (globalEvent?.type == "responseFileUpload") {
      let aryFiles = [];

      setAttachmentIds([...attachmentIds, globalEvent?.data?.attachment?.id]);

      aryFiles.push(globalEvent?.data.attachment);

      setAttachmentFiles([...attachmentFiles, ...aryFiles]);

      let collectedData = {};
      collectedData["asset"] = {};
      if (id) {
        collectedData["asset"]["id"] = id;
      }
      collectedData["asset"]["assetType"] = "bankAccount";
      collectedData["attachmentIds"] = [
        ...attachmentIds,
        globalEvent?.data?.attachment?.id,
      ];

      setGlobalEvent({ type: "doSaveAssetImage", data: collectedData });
    }

    if (globalEvent?.type == "responseSaveAssetImage") {
      setAttachmentIds([]);
	  if (globalEvent?.data?.asset?.id) {
        setID(globalEvent?.data?.asset.id ? globalEvent?.data?.asset.id : null);
      }
    }

    if (globalEvent?.type == "responseDeleteAttachment") {
      if (state?.data?.id) {
        setGlobalEvent({
          type: "doGetAttachments",
          data: { id: state?.data?.id },
        });
      }
    }

    if (globalEvent?.type == "responseGetAttachments") {
      //console.log(globalEvent?.data.attachments);
      let aryFiles = [];

      const length = Array.isArray(globalEvent?.data.attachments)
        ? globalEvent?.data.attachments.length
        : 0;
      for (let i = 0; i < length; i++) {
        aryFiles.push(globalEvent?.data.attachments[i]);
      }

      setAttachmentFiles([...aryFiles]);
    }
  }, [globalEvent]);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [editMode]);

  return (
    <>
      <DefaultLayout globalEvent={globalEvent} setGlobalEvent={setGlobalEvent}>
        {editMode !== true && (
          <Box
            className="my-container"
            sx={{
              mt: { xs: 0, sm: 8 },
              mb: 20,
              minHeight: "100vh",
              textAlign: "left",
            }}
          >
            <Grid container>
              <Grid item xs={12}>

                <AssetHeader
                chid={chid}
                id={id}
                setEditMode={setEditMode}
                setGlobalEvent={setGlobalEvent}
                titleKey={'asset.bankAccountData'}  />

              </Grid>
              <Grid item xs={12} md={7} sx={{ pr: { md: 3 } }}>
                <Card
                  className="add-asset-form-card"
                  sx={{ p: 2, width: { xs: "auto", md: "100%" } }}
                >
                  <CardContent>
                    <Typography variant="body2" sx={{ fontWeight: 700, mb: 0 }}>
                      {bankName} {ReactHtmlParser(t("asset.bankAccountTitle"))}
                    </Typography>
                    <Typography variant="body4" sx={{ color: "primary.main" }}>
                      {accountNumber}
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  className="add-asset-form-card"
                  sx={{ p: 2, width: { xs: "auto", md: "100%" }, my: 2 }}
                >
                  <CardContent>
                    <Typography variant="body2" sx={{ fontWeight: 700, mb: 0 }}>
                      {ReactHtmlParser(t("asset.bankAccountDescription"))}
                    </Typography>
                    <Typography
                      variant="body4"
                      sx={{ color: "primary.main", mt: 2 }}
                    >
                      {description} 
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  className="add-asset-form-card"
                  sx={{ px: 2, py: 1, width: { xs: "auto", md: "100%" } }}
                >
                  <CardContent
                    sx={{
                      "&.MuiCardContent-root": {
                        py: 1,
                      },
                    }}
                  >
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      justifyContent={{ xs: "center", sm: "space-between" }}
                      alignItems={{ xs: "space-between", sm: "center" }}
                      sx={{ mb: 0 }}
                    >
                      <Box>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 700,
                            mb: 0,
                            color: "primary.light",
                          }}
                        >
                          {ReactHtmlParser(t("asset.actualBalance"))}:
                        </Typography>
                        <Typography
                          variant="body4"
                          sx={{ color: "primary.light" }}
                        >
                          {ReactHtmlParser(t("common.refreshed"))}:  <DateFormatter timeStamp={lastUpdate} />
                        </Typography>
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 700 }}
                      >{`${formatValue(value)} ${currency}`}</Typography>
                    </Stack>
				  </CardContent>
                </Card>
				
				<AssetHeaderBottom chid={chid}
                id={id}
                setEditMode={setEditMode}
                setGlobalEvent={setGlobalEvent}
                titleKey={'asset.bankAccountData'}  />
			    
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                sx={{ pl: { xs: 0, md: 10 }, mt: { md: 0, xs: 6 } }}
              >
                <Box>
                  <Box sx={{ mb: 6 }}>
                    <Typography variant="body2" sx={{ fontWeight: 700, mb: 0 }}>
                      {ReactHtmlParser(t("asset.bankAccount.documentsTitle"))}{" "}
                      {attachmentFiles.length > 0 && (
                        <>({attachmentFiles.length})</>
                      )}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: "primary.main" }}
                    >
                      {ReactHtmlParser(
                        t("asset.bankAccount.documentsDescription")
                      )}
                    </Typography>
                  </Box>
                  <ShowFileOfAsset
                    globalEvent={globalEvent}
                    setGlobalEvent={setGlobalEvent}
                    itemList={attachmentFiles}
                    editMode={editMode}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}

        {/* - - - - - - - - - */}

        {editMode !== false && (
          <Box
            ref={formRef}
            component="form"
            className="my-container"
            onSubmit={handleSubmit(onSubmit, onError)}
          >
            <Grid
              sx={{
                mt: { xs: 0, sm: 8 },
                mb: 20,
                minHeight: "100vh",
                textAlign: "left",
              }}
              container
            >
              <Grid xs={12}>
                <Typography
                  variant="body1"
                  sx={{ mb: 4, pl: { xs: 2, sm: 0 }, fontWeight: 700 }}
                >
                  {ReactHtmlParser(t("asset.bankAccountNew"))}
                </Typography>
              </Grid>
              <Grid item xs={12} md={7} sx={{ pr: { md: 3 } }}>
                <Card
                  className="add-asset-form-card"
                  sx={{ p: 2, width: { xs: "auto", md: "100%" } }}
                >
                  <CardContent>
                    <Typography variant="body2" sx={{ fontWeight: 700, mb: 4 }}>
                      {ReactHtmlParser(t("asset.bankAccount.bankData"))}
                    </Typography>
                    <Box
                      sx={{
                        mt: 4,
                      }}
                    >
                      <Stack spacing={2} sx={{ mb: 4 }}>
                        <div>
                          <Autocomplete
                            options={bankNameList}
                            value={bankName}
                            onSelect={(event) => {
                              setBankName(event.target.value);
                            }}
							onInputChange={(e, value) => {
								//console.log('###: '+value);
								setBankName(value);
							}}
							
                            {...register("bankName", {
                              required: t("errors.field.required"),
                            })}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                key="bankName"
                                className="asset-field-small"
                            required={true}
                                label={ReactHtmlParser(t("field.bankName"))}
                                type="text"
                                onChange={(event) => {
                                  setBankName(event.target.value);
                                }}
                              />
                            )}
                          />

                          {errors.bankName && (
                            <span role="alert">{errors.bankName.message}</span>
                          )}
                        </div>

                        <div>
                          <TextField
                            key="accountNumber"
                            className="asset-field-fullwidth"
                            label={ReactHtmlParser(t("field.accountNumber"))}
                            required={false}
                            type="text"
                            onChange={(event) => {
                              setAccountNumber(event.target.value);
                            }}
                            {...register("accountNumber", {
                              /*required: t("errors.field.required"),
                              ,
          pattern: {
            value: ,
            message: "Entered value does not match format"
          },*/
                            })}
                          />

                          {errors.accountNumber && (
                            <span role="alert">
                              {errors.accountNumber.message}
                            </span>
                          )}
                        </div>

                        <div>
                          <TextField
                            key="accountCurrency"
                            select
                            closeMenuOnSelect={false}
                            blurInputOnSelect={false}
                            className="asset-field-currency"
                            label={ReactHtmlParser(t("field.accountCurrency"))}
                            value={accountCurrency}
                            defaultValue={accountCurrency}
                            required={false}
                            onChange={(ev) => {
                              ev.preventDefault();
                              if (ev.target.value == "MORE") {
                                setAccountCurrencyMore(true);

                                setTimeout(() => {
                                  setOpenAccountCurrency(true);
                                }, 1000);
                              } else {
                                setAccountCurrency(ev.target.value);
                                setCurrency(ev.target.value);
                              }
                            }}
                            inputProps={{
                              open: openAccountCurrency,
                              onClose: (ev) => {
                                //console.log(ev.target);
                                ev.stopPropagation();
                                ev.preventDefault();
                                setOpenAccountCurrency(false);
                                return false;
                              },
                              onOpen: (ev) => {
                                //console.log(ev.target);
                                ev.stopPropagation();
                                ev.preventDefault();
                                setOpenAccountCurrency(true);
                                return false;
                              },
                            }}
                            {...register("accountCurrency", {
                              /*required: t("errors.field.required"),*/
                              onChange: (ev) => {
                                if (ev.target.value == "MORE") {
                                  ev.defaultMuiPrevented = true;
                                  ev.stopPropagation();
                                  ev.preventDefault();
                                  setAccountCurrencyMore(true);
                                  setTimeout(() => {
                                    setOpenAccountCurrency(true);
                                  }, 250);
                                  return false;
                                } else {
                                  setAccountCurrency(ev.target.value);
                                  setCurrency(ev.target.value);
                                }
                              },

                              /*,
          pattern: {
            value: ,
            message: "Entered value does not match format"
          },*/
                            })}
                          >
                            <MenuItem
                                value={accountCurrency}
                                id={0}
                                key={0}
                                onClick={(ev) => {
                                  ev.defaultMuiPrevented = true;
                                  ev.stopPropagation();
                                  ev.preventDefault();
                                  return false;
                                }}
                                style={{
                                  display: accountCurrencyMore ? 'none' : 'block'
                                }}
                              >
							  {accountCurrency}
                              </MenuItem>
                            {Object.keys(currencyMinJSON).map((key, index) => {
                              return (
                                !accountCurrencyMore && currencyJSON[key].code !== accountCurrency && (
                                  <MenuItem
                                    closeOnSelect={false}
                                    value={currencyJSON[key].code}
                                    id={index}
                                    key={index}
                                    style={{
                                      display: accountCurrencyMore ? 'none' : 'block'
                                    }}
                                  >
                                    {currencyJSON[key].code}
                                  </MenuItem>
                                )
                              );
                            })}
                            <MenuItem
                                value="MORE"
                                id={0}
                                key={0}
                                onClick={(ev) => {
                                  ev.defaultMuiPrevented = true;
                                  ev.stopPropagation();
                                  ev.preventDefault();
                                  return false;
                                }}
                                style={{
                                  display: accountCurrencyMore ? 'none' : 'block'
                                }}
                              >
                                {t("common.moreCurrency")}
                              </MenuItem>

                            {Object.keys(currencyJSON).map((key, index) => {
                              return (
                                accountCurrencyMore && (
                                  <MenuItem
                                    value={currencyJSON[key].code}
                                    id={index}
                                    key={index}
                                  >
                                    {currencyJSON[key].code}
                                  </MenuItem>
                                )
                              );
                            })}
                          </TextField>

                          {errors.accountCurrency && (
                            <span role="alert">
                              {errors.accountCurrency.message}
                            </span>
                          )}
                        </div>
                      </Stack>
                    </Box>
                    <Box
                      sx={{
                        my: 4,
                        borderTop: "2px solid #EBEBEB",
                      }}
                    >
                      <Stack
                        direction={"row"}
                        spacing={1}
                        sx={{ my: 4 }}
                        alignItems={"center"}
                      >
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                          {ReactHtmlParser(t("field.description"))}
                        </Typography>
                        <Typography variant="caption">
                          ({ReactHtmlParser(t("common.optional"))})
                        </Typography>
                      </Stack>
                      <TextareaAutosize
                        key="description"
                        placeholder={ReactHtmlParser(t("asset.bankAccount.descriptionPlaceholder"))}
                        {...register("description", {
                          /*,
          pattern: {
            value: ,
            message: "Entered value does not match format"
          },*/
                        })}
                        value={description}
                        onChange={(event) => {
                          setDescription(event.target.value);
                        }}
                        style={{
                          font: "inherit",
                          width: "100%",
                          height: "133px",
                          resize: "none",
                          border: "1px solid #C6C6C6",
                          marginLeft: "-10px",
                          borderRadius: "24px",
                          paddingTop: "16px",
                          paddingLeft: "16px",
                          paddingRight: "5px",
                          paddingBottom: "16px",
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        my: 4,
                      }}
                    >


                      <Stack
                        onClick={handleShow}
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        sx={{ cursor: "pointer" }}
                      >


                        <Stack
                          direction={"row"}
                          spacing={1}
                          sx={{ mb: 4 }}
                          alignItems={"center"}
                        >
                          <Typography variant="body2" sx={{ fontWeight: 700 }}>
                            {ReactHtmlParser(t("asset.actualBalance"))}
                          </Typography>
                          <Typography variant="caption">
                            ({ReactHtmlParser(t("common.optional"))})
                          </Typography>
                        </Stack>

                      </Stack>
                        <Stack
                          spacing={2}
                          direction={{ xs: "column", sm: "row" }}
                        >
                          <div>
                            <TextField
                              key="value"
                              className="asset-field-small"
                              label={ReactHtmlParser(t("field.value"))}
                              type="text"
                              onFocus={(event) => {
                                event.target.select();
                              }}
                              onChange={(event) => {
                                setVal(event.target.value);
                              }}
                              {...register("value", {
                                required: t("errors.field.required"),
                                onChange: (event) => {
                                  //console.log(
                                  //  formatValue(
                                  //    event.target.value.replace(/\D/g, "") * 1
                                  //  )
                                  //);
                                  event.target.value = formatValue(
                                    event.target.value.replace(/\D/g, "") * 1
                                  );
                                },
                                /*,
          pattern: {
            value: ,
            message: "Entered value does not match format"
          },*/
                              })}
                            />

                            {errors.value && (
                              <span role="alert">{errors.value.message}</span>
                            )}
                          </div>

                          <div style={{display: "flex", alignItems: "center"}}>
                            <Stack
                              spacing={2}
                              direction={"column"}
                              alignItems={"center"}
                              justifyContent={"middle"}
                            >
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 700, mb: 0 }}
                              >
                                {currency}
                              </Typography>
                            </Stack>
                          </div>
                        </Stack>
                    </Box>
                    <Stack
                      direction={"row"}
                      spacing={2}
                      sx={{ mt: 4, alignItems: "center" }}
                    >
                      <Checkbox
                        checked={hasPOD}
                        onChange={(event, val) => {
                          setHasPOD(val);
                        }}
                      />

                      <Typography
                        variant="body3"
                        sx={{
                          fontSize: "14px",
                          color: "#000000",
                          lineHeight: "17.64px",
                        }}
                      >
                        {ReactHtmlParser(t("asset.bankAccount.hasPOD"))}
                      </Typography>
                    </Stack>
                    {hasPOD && (
                      <TextField
                        key="hasPODText"
                        defaultValue={hasPODText}
                        className="asset-field-small"
                        label={ReactHtmlParser(t("field.hasPODText"))}
                        type="text"
                        onChange={(event) => {
                          setHasPODText(event.target.value);
                        }}
                        {...register("hasPODText", {
                          /*,required: t("errors.field.required"),
								
          pattern: {
            value: ,
            message: "Entered value does not match format"
          },*/
                        })}
                      />
                    )}
                  </CardContent>
                </Card>

                <Stack
                  direction={"row"}
                  spacing={2}
                  sx={{
                    mt: 4,
                    justifyContent: { md: "end" },
                    alignItems: "center",
                  }}
                >
                  <Button
                    variant="text"
                    className="secondary-blue-text-btn"
                    onClick={(e) => {
                      if (!id) {
                        navigate("/asset-list");
                      } else {
                        setEditMode(false);
                      }
                    }}
                  >
                    {ReactHtmlParser(t("common.buttondocancel"))}
                  </Button>

                  <Button
                    type="button"
                    variant="contained"
                    className="small-btn secondary-blue-btn"
                    disabled={!isSaveEnabled}
                    onClick={(ev) => {
                      formRef.current.requestSubmit();
                    }}
                    endIcon={
                      <svg
                        width="12"
                        height="9"
                        viewBox="0 0 12 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.2929 5H0.5C0.223858 5 0 4.77614 0 4.5C0 4.22386 0.223858 4 0.5 4H10.2929L7.14645 0.853553C6.95118 0.658291 6.95118 0.341709 7.14645 0.146447C7.34171 -0.0488155 7.65829 -0.0488155 7.85355 0.146447L11.8536 4.14645C12.0488 4.34171 12.0488 4.65829 11.8536 4.85355L7.85355 8.85355C7.65829 9.04882 7.34171 9.04882 7.14645 8.85355C6.95118 8.65829 6.95118 8.34171 7.14645 8.14645L10.2929 5Z"
                          fill="#E5FE4A"
                        />
                      </svg>
                    }
                  >
                    {ReactHtmlParser(t("asset.bankAccountSave"))}
                  </Button>
                </Stack>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                sx={{ pl: { xs: 0, md: 10 }, mt: { md: 0, xs: 6 } }}
              >
                <Box>
                  <Box sx={{ mb: 6 }}>
                    <Typography variant="body2" sx={{ fontWeight: 700, mb: 0 }}>
                      {ReactHtmlParser(t("asset.bankAccount.documentsTitle"))}{" "}
                      {attachmentFiles.length > 0 && (
                        <>({attachmentFiles.length})</>
                      )}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: "primary.main" }}
                    >
                      {ReactHtmlParser(
                        t("asset.bankAccount.documentsDescription")
                      )}
                    </Typography>
                  </Box>
                  <AddFileToAsset onFileUpload={onFileUpload} />
                  <Box sx={{ mt: 2 }}>
                    <ShowFileOfAsset
                      globalEvent={globalEvent}
                      setGlobalEvent={setGlobalEvent}
                      itemList={attachmentFiles}
                      editMode={editMode}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </DefaultLayout>
    </>
  );
};

export default EditBankAccount;
